import React, { useState, useRef, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  setEditingPlaceholderContext,
  setPlaceholderModalVisible,
} from '../../store/slices/editorUISlice';
import checkmarkIcon from '../../../../assets/images/view-meeting/checkmark.svg';

import '../../../../modals/MeetingNotesModal/styles.scss';
import classes from '../../../../modals/MeetingNotesModal/styles.module.scss';

export default function PlaceholderModal({ onSave }) {
  const dispatch = useDispatch();
  const isVisible = useSelector((state) => state.editorUI.isPlaceholderModalVisible);
  const editingPlaceholderContext = useSelector(
    (state) => state.editorUI.editingPlaceholderContext
  );
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const titleInputRef = useRef(null);

  useEffect(() => {
    if (isVisible) {
      setTitle(editingPlaceholderContext?.title || '');
      setDescription(editingPlaceholderContext?.description || '');
      setTimeout(() => titleInputRef.current?.focus(), 100);
    }
  }, [isVisible, editingPlaceholderContext]);

  const handleClose = () => {
    setTitle('');
    setDescription('');
    dispatch(setPlaceholderModalVisible(false));
    dispatch(setEditingPlaceholderContext(null));
  };

  const handleSave = () => {
    if (!title.trim()) return;
    onSave({
      title,
      description,
      isEditing: !!editingPlaceholderContext?.assetId,
    });
  };

  if (!isVisible) return null;

  const isAddDisabled = !title.trim();
  const isEditing = !!editingPlaceholderContext?.assetId;

  return (
    <Modal
      show={isVisible}
      centered
      contentClassName={classes.MeetingNotesModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      <header className={classes.header}>
        <i
          className={classes.closeIcon}
          onClick={handleClose}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter') handleClose(); }}
        >
          Close
        </i>
        <h1>{isEditing ? 'Edit Placeholder' : 'Add Placeholder'}</h1>
      </header>
      <div className={classes.editorContainer}>
        <div className={classes.label}>Placeholder Title</div>
        <input
          ref={titleInputRef}
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g., Safety walkthrough recording"
          onKeyDown={(e) => { if (e.key === 'Enter' && !isAddDisabled) handleSave(); }}
          style={{
            width: '100%',
            padding: '26px 38px',
            border: '1px solid #666666',
            borderRadius: 18,
            fontSize: 18,
            outline: 'none',
            fontFamily: 'inherit',
            marginBottom: 24,
          }}
        />
        <div className={classes.label}>Description (optional)</div>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Instructions for what content should go here..."
          rows={6}
          style={{
            width: '100%',
            padding: '26px 38px',
            border: '1px solid #666666',
            borderRadius: 18,
            fontSize: 18,
            outline: 'none',
            fontFamily: 'inherit',
            resize: 'vertical',
          }}
        />
      </div>
      <footer className={classes.footer}>
        <div className={classes.buttons}>
          <button
            className={classes.saveButton}
            type="button"
            onClick={handleSave}
            disabled={isAddDisabled}
            style={isAddDisabled ? { opacity: 0.4, cursor: 'not-allowed' } : {}}
          >
            <img src={checkmarkIcon} alt={isEditing ? 'Save' : 'Add'} />
          </button>
        </div>
      </footer>
    </Modal>
  );
}
